import React from 'react';

import { JsonFieldType } from '../schema';
import { fieldTypeMatchesValue } from '../utils';

import AiTextToolCheckbox from './AiTextToolCheckbox';
import AiTextToolSelect from './AiTextToolSelect';
import AiTextToolTextInput from './AiTextToolTextInput';
import { AiTextToolInputProps } from './types';

const AiTextToolInput: React.FC<AiTextToolInputProps> = ({
  field,
  value: currentValue,
  onChange,
  disabled,
  error,
}) => {
  const { type } = field;

  if (type === JsonFieldType.Text) {
    const value = fieldTypeMatchesValue(type, currentValue) ? currentValue : '';

    return (
      <AiTextToolTextInput
        disabled={disabled}
        error={error}
        field={field}
        value={value}
        onChange={onChange}
      />
    );
  }

  if (type === JsonFieldType.Select) {
    const value = fieldTypeMatchesValue(type, currentValue)
      ? currentValue
      : field.options[0].id;

    return (
      <AiTextToolSelect
        disabled={disabled}
        error={error}
        field={field}
        value={value}
        onChange={onChange}
      />
    );
  }

  if (type === JsonFieldType.Checkbox) {
    const value = fieldTypeMatchesValue(type, currentValue)
      ? currentValue
      : false;

    return (
      <AiTextToolCheckbox
        disabled={disabled}
        field={field}
        value={value}
        onChange={onChange}
      />
    );
  }

  return <></>;
};

export default AiTextToolInput;
